import { createAction, props } from '@ngrx/store';

export const initSignalrConnection = createAction(
  '[Connect] Initialize signalr connection',
);

export const initSignalrConnectionSuccess = createAction(
  '[Connect] Initialize signalr connection success',
);

export const initSignalrConnectionFailure = createAction(
  '[Connect] Initialize signalr connection failure',
);

export const stopSignalrConnection = createAction(
  '[Connect] Stop signalr connection',
);

export const signalrReconnected = createAction(
  '[Connect] Reconnect SignalR connection',
);

export const sendSignalrMessage = createAction(
  '[Connect] Send signalr message',
  props<{ methodName: string; params: unknown[] }>(),
);

export const openSignalrChannel = createAction(
  '[Connect] Open an specific signalr channel',
  props<{ message: string }>(),
);

export const closeSignalrChannel = createAction(
  '[Connect] Close an specific signalr channel',
  props<{ message: string }>(),
);
